import { Component, OnInit } from '@angular/core';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-custom-toast',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './custom-toast.component.html',
  styleUrl: './custom-toast.component.css'
})

export class CustomToastComponent extends Toast implements OnInit {

  extraMessage: string = '';

  constructor(
    protected toastrService: ToastrService,
    public toastPackage: ToastPackage,
    public translate: TranslateService,
  ) {
    super(toastrService, toastPackage);
  }

  ngOnInit(): void {

    const message = this.toastPackage.message;

    if (message.includes(' | ')) {
      const [main, sub] = message.split(' | ');
      this.toastPackage.message = main.trim();
      this.extraMessage = sub.trim();
    } 
    else if (message.includes('====')) {
      const [main, sub] = message.split('====');
      this.toastPackage.message = main.trim();
      this.extraMessage = sub.trim();
    } 

  }

}